import {FC} from 'react'

import {Trans} from '@/i18n'
import {theme} from '@/theme/theme'
import {useLanguage} from '@/utils/i18n/language'
import {getRouteToPrivacyPolicy} from '@/utils/router'

import {Text, TextFontWeight, TextVariant} from '../content/Text'
import {TransLink} from '../TransLink'

export type FormConsentNoteType = {
  note: string
  linkHrefs?: string[]
  values?: Record<string, string>
}

export const FormConsentNote: FC<FormConsentNoteType> = ({note, linkHrefs, values}) => {
  const language = useLanguage()

  // privacy policy is the last link in every consent note, so it is included only once here
  const hrefs = linkHrefs ? [...linkHrefs, getRouteToPrivacyPolicy(language)] : []

  return (
    <>
      <div className="note">
        <Text variant={TextVariant.caption} element="p" align="center">
          <Trans
            i18nKey={note}
            values={values}
            components={[
              // Trans component indices start at 0, but our translation uses <1>, <2>, etc.
              // so we insert 'undefined' at index 0 to align component positions correctly.
              undefined,
              ...hrefs.map((link, i) => (
                <TransLink key={i} href={link} fontWeight={TextFontWeight.medium} />
              )),
            ]}
          />
        </Text>
      </div>

      <style jsx>{`
        .note {
          margin: ${theme.spacing[3]} auto 0;
          max-width: 380px;
        }
      `}</style>
    </>
  )
}
